// extracted by mini-css-extract-plugin
export default {"slide":"styles_slide__eLizZ","slide__active":"styles_slide__active__tPV9U","quote":"styles_quote__Nht37"};